import { Component, ComponentRef, OnInit, ViewContainerRef } from '@angular/core';
import { Form } from '@models/form';
import { FormFieldDefinition } from '@models/form-field-definition';
import { FormService } from '@services/form.service';
import { FormDetailComponent } from '../base/form-detail/form-detail.component';

@Component({
    selector: 'cp-account-reps',
    templateUrl: './account-reps.component.html',
    styleUrls: ['./account-reps.component.less'],
    standalone: false
})
export class AccountRepsComponent implements OnInit {
    constructor(private _formService: FormService, private _viewContainerRef: ViewContainerRef) {}

    ngOnInit(): void {
        this._formService.getForm('cpCustResponsible').subscribe(
            (fields: FormFieldDefinition[]) => {
                this.showForm('cpCustResponsible', 'cpCustResponsible', fields);
            }
        );
    }

    private showForm(formId: string, dataQueryId: string, fields: FormFieldDefinition[]) {
        const ref: ComponentRef<FormDetailComponent> =
            this._viewContainerRef.createComponent(FormDetailComponent);

        ref.instance.formId = formId;
        ref.instance.pageId = 'home';
        ref.instance.fields = Form.convertToFormFields(fields);
        ref.instance.dataQueryId = dataQueryId;
        ref.instance.autoRunDataQuery = true;
        ref.instance.isLoginForm = false;
        ref.instance.isAuthenticationForm = false;
        ref.changeDetectorRef.detectChanges();
    }
}
